// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import { ENUMS } from "../../utils/Enums";
import { showCategorySelector } from "../../utils/Utils";

export default function GenericDoubleValue(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, inputParams = {}, edit = false, category = false } = props;

    const { value = 1, type = 0 } = filter;

    let text = filter.text;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;
    if (_data) {
        text = _data.text;
    }


    const fields = [
        { key: "value_1", value: (edit) ? filter.value_1 : "", help: "Enter a value." },
        { key: "value_2", value: (edit) ? filter.value_2 : "", help: "Enter a value." },
        { label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const value_1 = tabs.find(f => f.key === "value_1").value;
        const value_2 = tabs.find(f => f.key === "value_2").value;
        const _f = {
            ...FILTER,
            type: value,
            value_1: value_1.toString(),
            value_2: value_2.toString()
        }
        onSave(_f, filter);
    }

    const drawCategorySelect = (update, setIndex) => {

        if (!category) {
            return;
        }
        setIndex("save");
        showCategorySelector({
            callback: (e) => {
                if (e) {
                    update("value_1", e.category_1)
                    update("value_2", e.category_2)
                }
                setIndex("save");
            }
        })
    }


    return (
        <FilterBase controller={controller} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, setIndex, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <Input onPageUp={() => drawCategorySelect(update, setIndex)} doubleclick={() => drawCategorySelect(update, setIndex)} {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />
                        <Input onPageUp={() => drawCategorySelect(update, setIndex)} doubleclick={() => drawCategorySelect(update, setIndex)} {...editProps("value_2")} {...inputParams} onFill={(e) => proceed(e)} />
                        <div className={(index === "save") ? "ui-outline" : "" }style={{"border-radius" : "2px"}}><Button  onClick={() => save(tabs)} {...editProps("save")}>Save</Button></div>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
